export const getGameWs = (state) => state.gameWs;
export const getWaitingDraw = (state) =>
    state.gameWs.waitingDraw || state.gameWs.drawOffer;
export const getCurrentGameId = (state) => state.gameWs.matched.data.id;
export const getGameWsSearch = (state) => getGameWs(state).search;
export const getNotificationList = (state) => getGameWs(state).notificationList;
export const getFriendInteraction = (state) =>
    getGameWs(state).friendInteraction;
export const getGameWsUser = (state) => getGameWs(state).user;
